import { PLAYER_SAVE_SECTIONS, type PlayerSaveSection } from "@/cloud/player-save-docs";

const LOCAL_TS_PREFIX = "mind-survival/cloud-section-ts/v1";

export type SectionTimestamps = Record<PlayerSaveSection, number>;

function emptySectionTimestamps(): SectionTimestamps {
  return { character: 0, gameState: 0, home: 0, skills: 0 };
}

function localTsKey(userId: string): string {
  return `${LOCAL_TS_PREFIX}:${userId}`;
}

export function readLocalSectionTimestamps(userId: string): SectionTimestamps {
  const raw = localStorage.getItem(localTsKey(userId));
  if (!raw) return emptySectionTimestamps();
  try {
    const parsed = JSON.parse(raw) as Partial<SectionTimestamps>;
    const base = emptySectionTimestamps();
    for (const section of PLAYER_SAVE_SECTIONS) {
      const n = parsed[section];
      if (typeof n === "number" && Number.isFinite(n) && n >= 0) {
        base[section] = Math.floor(n);
      }
    }
    return base;
  } catch {
    return emptySectionTimestamps();
  }
}

export function writeLocalSectionTimestamps(userId: string, ts: SectionTimestamps): void {
  localStorage.setItem(localTsKey(userId), JSON.stringify(ts));
}

export function bumpPlayerSaveSectionTimestamp(userId: string, section: PlayerSaveSection): void {
  const ts = readLocalSectionTimestamps(userId);
  ts[section] = Date.now();
  writeLocalSectionTimestamps(userId, ts);
}
